// 计算经纬度距离
export const distance = (la1, lo1, la2, lo2) => {
  let La1 = (la1 * Math.PI) / 180.0;
  let La2 = (la2 * Math.PI) / 180.0;
  let La3 = La1 - La2;
  let Lb3 = (lo1 * Math.PI) / 180.0 - (lo2 * Math.PI) / 180.0;
  let s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(La3 / 2), 2) +
          Math.cos(La1) * Math.cos(La2) * Math.pow(Math.sin(Lb3 / 2), 2)
      )
    );
  s = s * 6378.137; //地球半径
  s = Math.round(s * 10000) / 10000;
  let distance = s;
  // let distance_str = "";

  // if (parseInt(distance) >= 1) {
  //   distance_str = distance.toFixed(1) + "km";
  // } else {
  //   distance_str = (distance * 1000).toFixed(1) + "m";
  // }
  // return distance_str;
  return distance;
};
// 排序
export const arrSort = (arr) => {
  let list = arr;
  list.sort(function (a, b) {
    return a.distance - b.distance;
  });
  for (let i = 0; i < list.length; i++) {
    if (parseInt(list[i].distance) >= 1) {
      list[i].distance = list[i].distance.toFixed(1) + "km";
    } else {
      list[i].distance = (list[i].distance * 1000).toFixed(1) + "m";
    }
  }
  return list;
};
// 获取当前位置跟经纬度
export const Geoloation = () => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        // console.log(r);
        console.log(r.accuracy, "--------r.accuracy");
        console.log(this.getStatus(), "----------this.getStatus()");
        let myGeo = new BMap.Geocoder();
        myGeo.getLocation(
          new BMap.Point(r.point.lng, r.point.lat),
          function (result) {
            resolve(result);
            //   if (r.accuracy != null) { } else {
            //   console.log(r.accuracy);
            //   reject(1);
            // }
          }
        );
        //   if (this.getStatus() == BMAP_STATUS_SUCCESS) {} else {
        //   reject(1);
        //   console.log(r.accuracy);
        //   console.log(this.getStatus());
        // }
      });
    }, 500);
  });
};
// export const Geoloation = () => {
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       const geolocation = new BMap.Geolocation();
//       geolocation.getCurrentPosition(function (r) {
//         if (this.getStatus() == BMAP_STATUS_SUCCESS) {
//           let myGeo = new BMap.Geocoder();
//           myGeo.getLocation(
//             new BMap.Point(r.point.lng, r.point.lat),

//             function (result) {
//               console.log(r.accuracy)
//               //拒绝获取地理位置：accuracy 为 null ；同意： accuracy 不为 null
//               if (r.accuracy == null) { //用户拒绝地理位置授权
//                 reject('拒绝授权');
//                 return;
//               } else {
//                 resolve(result);

//               }
//             }
//           );

//         } else { //用户允许地理位置授权
//           resolve('failed' + this.getStatus());
//         }

//         // console.log(r);

//       });
//     }, 500);
//   });
// };
// 获取地理正解析
export const GetPoint = (address, city) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let myGeo = new BMap.Geocoder();
      myGeo.getPoint(
        address,
        function (result) {
          if (result) {
            resolve(result);
          } else {
            reject("获取位置失败请稍后再试！");
          }
        },
        city
      );
    }, 500);
  });
};
// 搜索
export const searchPoint = (address) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let myGeo = new BMap.LocalSearch(address);
      myGeo.search(address);
      myGeo.setSearchCompleteCallback(function (result) {
        if (result) {
          resolve(result);
        }
      });
    }, 500);
  });
};
